import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';

import { CrudBoxModule } from '../crud-box/crud-box.module';
import { InputErrorModule } from '../input-error/input-error.module';
import { ListBoxModule } from '../list-box/list-box.module';
import { AdministratorsRoutes } from './administrators.routes';
import { AdministratorListComponent } from './administrator-list/administrator-list.component';
import { AdministratorFormComponent } from './administrator-form/administrator-form.component';
import { AdministratorService, AdministratorFormService } from './shared';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CrudBoxModule,
    InputErrorModule,
    ListBoxModule,
    AdministratorsRoutes
  ],
  declarations: [
    AdministratorListComponent,
    AdministratorFormComponent
  ],
  providers: [
    AdministratorService,
    AdministratorFormService
  ]
})
export class AdministratorsModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/administrators.module.ts